import { AnalyticsAttributesProvider, Stack } from "../../components";
import { UiBlockModel } from "../../models";
import { renderViewModels } from "../../render-view-model";
import {
    BackgroundFieldValue,
    getColorsFromBackgroundField
} from "../../styles";
import { MapModelToProps } from "../../utils";

import { Block } from "./UiBlock.styles";

export type UiBlockProps = MapModelToProps<UiBlockModel>;

const UiBlock = ({
    model: {
        content: {
            title,
            shadow,
            roundedCorners,
            background,
            children,
            verticalAlign,
            appearance,
            fullHeight,
            orientation,
            spacing,
            border
        }
    }
}: UiBlockProps) => {
    return (
        <AnalyticsAttributesProvider value={{ labelEnglish: title }}>
            <Block
                data-testid="block"
                shadow={shadow}
                roundedCorners={roundedCorners}
                appearance={appearance}
                fullHeight={fullHeight}
                border={border}
                {...getColorsFromBackgroundField(background)}
                backgroundField={background as BackgroundFieldValue}
            >
                {children && (
                    <Stack
                        fullHeight={fullHeight}
                        orientation={orientation}
                        spacing={spacing}
                        verticalAlign={verticalAlign}
                    >
                        {renderViewModels(children)}
                    </Stack>
                )}
            </Block>
        </AnalyticsAttributesProvider>
    );
};

export default UiBlock;
